<template>
  <ShowingTimePlusOrderFormHeader
    v-if="showingTimePlusBookingIntent"
    :booking-intent="showingTimePlusBookingIntent"
    :order="page.props.order"
  />
  <div
    scroll-region
    id="app-content-wrapper"
    class="flex flex-col h-full overflow-y-auto"
    :style="`background-color: ${backgroundColor};`"
  >
    <div class="w-full max-w-4xl mx-auto my-12 xs:px-0 sm:px-6">
      <Stack space="xlarge">
        <OrderFormHeader
          v-if="showOrderFormHeader"
          :title="page.props.meta?.title"
          :isLogoVisible="page.props.meta?.show_logo"
          :logoUrl="page.props.meta?.logo_url"
          :logoAlt="page.props.meta?.logo_alt"
          :logoTitle="page.props.meta?.logo_alt"
          :description="page.props.meta?.description"
          :companyUrl="page.props.meta?.company_website_url"
        />
        <div>
          <slot />
        </div>
        <PoweredByAryeo v-if="page.props.meta?.has_aryeo_branding" :color="textColor" />
      </Stack>
    </div>
    <GoogleTagManagerScripts
      v-if="page.props.meta.google_tag_manager_id"
      :googleTagManagerId="page.props.meta.google_tag_manager_id"
    />
    <FlashMessage />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { Stack } from '@aryeo/runway'
import { usePage } from '@inertiajs/vue3'

import GoogleTagManagerScripts from '@/Components/Customer/OrderForms/LayoutParts/GoogleTagManagerScripts.vue'
import OrderFormHeader from '@/Components/Customer/OrderForms/LayoutParts/OrderFormHeader.vue'
import FlashMessage from '@/Components/Shared/FlashMessage.vue'
import PoweredByAryeo from '@/Components/Shared/Global/PoweredByAryeo.vue'
import ShowingTimePlusOrderFormHeader from '@/Components/Customer/OrderForms/LayoutParts/ShowingTimePlusOrderFormHeader.vue'

import { isLightColor } from '@/Utils/Color.js'

const page = usePage()

const backgroundColor = ref(page.props.meta?.background_color)

// On the Order Landing page, we have direct access to the booking intent and no order object
// On all other steps, we have access through the order
const showingTimePlusBookingIntent = computed(
  () =>
    page.props.showingtimeplus_booking_intent || page.props.order?.showingtimeplus_booking_intent
)

const showOrderFormHeader = computed(() => page.props.order_form_session?.show_header ?? true)
const textColor = computed(() => (isLightColor(backgroundColor.value) ? 'body' : 'white'))
</script>
